import { graphql, HttpResponse } from 'msw'
import {
  CashEquivalentCategory,
  EquitiesSector,
  FixedIncomeCategory,
  InvestmentAccountStatus,
  IraDistributionType,
  type InvestmentBrokerageAccount,
  type InvestmentInheritedIRAAccount,
  type InvestmentInheritedRothIRAAccount,
  type InvestmentJointBrokerageTenantsInCommonAccount,
  type InvestmentJointBrokerageTenantsInCommonCompanionAccount,
  type InvestmentJointBrokerageTenantsWithRightOfSurvivorshipAccount,
  type InvestmentJointBrokerageTenantsWithRightOfSurvivorshipCompanionAccount,
  type UpdateInvestmentAccountName,
} from '../../../models'

export const investmentAccountDetailMock: InvestmentBrokerageAccount = {
  __typename: 'InvestmentBrokerageAccount',
  alias: 2,
  accountName: 'Brokerage Account',
  accountNumber: '123456789',
  status: InvestmentAccountStatus.OPEN,
  attributes: {
    minimumDeposit: 250000,
    minimumDepositMet: true,
    acatAllowed: true,
    clientWithdrawalAllowed: true,
    clientDepositAllowed: true,
  },
  balance: {
    investedBalance: {
      amount: 20000,
      currencyCode: 'USD',
    },
    accountValue: {
      amount: 24000,
      currencyCode: 'USD',
    },
    cashBalance: {
      amount: 700,
      currencyCode: 'USD',
    },
    pendingWithdrawal: {
      amount: 0.0,
      currencyCode: 'USD',
    },
    availableForWithdrawal: {
      amount: 16000,
      currencyCode: 'USD',
    },
    amountSinceInception: {
      amount: 4000,
      currencyCode: 'USD',
    },
  },
  assetAllocation: {
    __typename: 'InvestmentAssetAllocation',
    preference: {
      equities: 45,
      fixedIncome: 30,
      cashEquivalent: 25,
    },
    equities: {
      __typename: 'InvestmentEquitiesAsset',
      amount: {
        amount: 160,
        currencyCode: 'USD',
      },
      percentage: 44.94,
      holdings: [
        {
          name: 'Pfizer',
          symbol: 'PFE',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'Apple',
          symbol: 'AAPL',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'BlackRock',
          symbol: 'BLK',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'Netflix',
          symbol: 'NFLX',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'Caterpillar',
          symbol: 'CAT',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'Raytheon',
          symbol: 'RTX',
          amount: {
            amount: 85.45,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'FPL',
          symbol: 'FPL',
          amount: {
            amount: 10,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 20,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'Airbnb',
          symbol: 'ABNB',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'CBS',
          symbol: 'CBS',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
      ],
      sectors: [
        {
          sector: EquitiesSector.HEALTHCARE,
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          percentage: 12.5,
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          sector: EquitiesSector.CONSUMER,
          amount: {
            amount: 21,
            currencyCode: 'USD',
          },
          percentage: 12.5,
          holdings: [
            {
              name: 'Apple',
              symbol: 'AAPL',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          sector: EquitiesSector.FINANCIAL,
          amount: {
            amount: 22,
            currencyCode: 'USD',
          },
          percentage: 12.5,
          holdings: [
            {
              name: 'BlackRock',
              symbol: 'BLK',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          sector: EquitiesSector.TECHNOLOGY,
          amount: {
            amount: 23,
            currencyCode: 'USD',
          },
          percentage: 12.5,
          holdings: [
            {
              name: 'Netflix',
              symbol: 'NFLX',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          sector: EquitiesSector.INDUSTRY,
          amount: {
            amount: 24,
            currencyCode: 'USD',
          },
          percentage: 12.5,
          holdings: [
            {
              name: 'Caterpillar',
              symbol: 'CAT',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Raytheon',
              symbol: 'RTX',
              amount: {
                amount: 85.45,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          sector: EquitiesSector.ENERGY,
          amount: {
            amount: 25,
            currencyCode: 'USD',
          },
          percentage: 12.5,
          holdings: [
            {
              name: 'FPL',
              symbol: 'FPL',
              costBasis: {
                amount: 20,
                currencyCode: 'USD',
              },
              amount: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          sector: EquitiesSector.REAL_ESTATE,
          amount: {
            amount: 26,
            currencyCode: 'USD',
          },
          percentage: 12.5,
          holdings: [
            {
              name: 'Airbnb',
              symbol: 'ABNB',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          sector: EquitiesSector.MEDIA,
          amount: {
            amount: 27,
            currencyCode: 'USD',
          },
          percentage: 12.5,
          holdings: [
            {
              name: 'CBS',
              symbol: 'CBS',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
      ],
    },
    fixedIncome: {
      __typename: 'InvestmentFixedIncomeAsset',
      amount: {
        amount: 100,
        currencyCode: 'USD',
      },
      percentage: 27.77,
      holdings: [
        {
          name: 'US Treasury',
          symbol: 'UST',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'California',
          symbol: 'CAM',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 5,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'Apple',
          symbol: 'APL',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'Junk',
          symbol: 'JNK',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
        {
          name: 'Euro',
          symbol: 'EUR',
          amount: {
            amount: 20,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
      ],
      categories: [
        {
          category: FixedIncomeCategory.GOVERNMENT_BONDS,
          percentage: 20,
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'US Treasury',
              symbol: 'UST',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          category: FixedIncomeCategory.MUNICIPAL_BONDS,
          percentage: 20,
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'California',
              symbol: 'CAM',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 5,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          category: FixedIncomeCategory.CORPORATE_BONDS,
          percentage: 20,
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'Apple',
              symbol: 'APL',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          category: FixedIncomeCategory.HIGH_YIELD_BONDS,
          percentage: 20,
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'Junk',
              symbol: 'JNK',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
        {
          category: FixedIncomeCategory.INTERNATIONAL_BONDS,
          percentage: 20,
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'Euro',
              symbol: 'EUR',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
      ],
    },
    cashEquivalent: {
      __typename: 'InvestmentCashEquivalentAsset',
      amount: {
        amount: 100,
        currencyCode: 'USD',
      },
      percentage: 27.77,
      holdings: [
        {
          name: 'Short-term',
          symbol: 'USD',
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 10,
            currencyCode: 'USD',
          },
          quantity: 0.0302,
        },
      ],
      categories: [
        {
          category: CashEquivalentCategory.CORPORATE,
          percentage: 20,
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'Short-term',
              symbol: 'USD',
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 10,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
      ],
    },
    other: {
      __typename: 'InvestmentOtherAsset',
      amount: {
        amount: 0,
        currencyCode: 'USD',
      },
      percentage: 0,
      holdings: [],
    },
  },
} as InvestmentBrokerageAccount

export const updateInvestmentAccountNameMock: UpdateInvestmentAccountName = {
  __typename: 'UpdateInvestmentAccountName',
  isSuccessful: true,
}

export const investmentInheritedIRAAccountMock: InvestmentInheritedIRAAccount = {
  __typename: 'InvestmentInheritedIRAAccount',
  alias: 10,
  accountName: 'Inherited IRA Account',
  accountNumber: '234567890',
  status: InvestmentAccountStatus.OPEN,
  attributes: {
    minimumDeposit: 250000,
    minimumDepositMet: true,
    acatAllowed: true,
    clientWithdrawalAllowed: true,
    clientDepositAllowed: true,
    iraWithdrawal: {
      withdrawalAmount: 25000,
      distributionType: IraDistributionType.QUALIFIED,
    },
  },
  balance: {
    investedBalance: {
      amount: 150000,
      currencyCode: 'USD',
    },
    accountValue: {
      amount: 175000,
      currencyCode: 'USD',
    },
    cashBalance: {
      amount: 5000,
      currencyCode: 'USD',
    },
    pendingWithdrawal: {
      amount: 0.0,
      currencyCode: 'USD',
    },
    availableForWithdrawal: {
      amount: 150000,
      currencyCode: 'USD',
    },
    amountSinceInception: {
      amount: 25000,
      currencyCode: 'USD',
    },
  },
  assetAllocation: {
    __typename: 'InvestmentAssetAllocation',
    preference: {
      equities: 60,
      fixedIncome: 25,
      cashEquivalent: 15,
    },
    equities: {
      __typename: 'InvestmentEquitiesAsset',
      amount: {
        amount: 105000,
        currencyCode: 'USD',
      },
      percentage: 60,
      holdings: [
        {
          name: 'S&P 500 ETF',
          symbol: 'SPY',
          amount: {
            amount: 50000,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 45000,
            currencyCode: 'USD',
          },
          quantity: 125.5,
        },
      ],
      sectors: [
        {
          sector: EquitiesSector.TECHNOLOGY,
          amount: {
            amount: 35000,
            currencyCode: 'USD',
          },
          percentage: 33.3,
          holdings: [
            {
              name: 'Apple Inc',
              symbol: 'AAPL',
              costBasis: {
                amount: 15000,
                currencyCode: 'USD',
              },
              amount: {
                amount: 17500,
                currencyCode: 'USD',
              },
              quantity: 75.25,
            },
          ],
        },
      ],
    },
    fixedIncome: {
      __typename: 'InvestmentFixedIncomeAsset',
      amount: {
        amount: 43750,
        currencyCode: 'USD',
      },
      percentage: 25,
      holdings: [
        {
          name: 'US Treasury 10Y',
          symbol: 'UST10Y',
          amount: {
            amount: 25000,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 24500,
            currencyCode: 'USD',
          },
          quantity: 25,
        },
      ],
      categories: [
        {
          category: FixedIncomeCategory.GOVERNMENT_BONDS,
          percentage: 60,
          amount: {
            amount: 26250,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'US Treasury 10Y',
              symbol: 'UST10Y',
              amount: {
                amount: 25000,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 24500,
                currencyCode: 'USD',
              },
              quantity: 25,
            },
          ],
        },
      ],
    },
    cashEquivalent: {
      __typename: 'InvestmentCashEquivalentAsset',
      amount: {
        amount: 26250,
        currencyCode: 'USD',
      },
      percentage: 15,
      holdings: [
        {
          name: 'Money Market Fund',
          symbol: 'MMKT',
          amount: {
            amount: 26250,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 26000,
            currencyCode: 'USD',
          },
          quantity: 26250,
        },
      ],
      categories: [
        {
          category: CashEquivalentCategory.CORPORATE,
          percentage: 100,
          amount: {
            amount: 26250,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'Money Market Fund',
              symbol: 'MMKT',
              amount: {
                amount: 26250,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 26000,
                currencyCode: 'USD',
              },
              quantity: 26250,
            },
          ],
        },
      ],
    },
    other: {
      __typename: 'InvestmentOtherAsset',
      amount: {
        amount: 0,
        currencyCode: 'USD',
      },
      percentage: 0,
      holdings: [],
    },
  },
} as InvestmentInheritedIRAAccount

export const investmentInheritedRothIRAAccountMock: InvestmentInheritedRothIRAAccount = {
  __typename: 'InvestmentInheritedRothIRAAccount',
  alias: 11,
  accountName: 'Inherited Roth IRA Account',
  accountNumber: '345678901',
  status: InvestmentAccountStatus.OPEN,
  attributes: {
    minimumDeposit: 250000,
    minimumDepositMet: true,
    acatAllowed: true,
    clientWithdrawalAllowed: true,
    clientDepositAllowed: true,
    iraWithdrawal: {
      withdrawalAmount: 15000,
      distributionType: 'QUALIFIED',
    },
  },
  balance: {
    investedBalance: {
      amount: 85000,
      currencyCode: 'USD',
    },
    accountValue: {
      amount: 95000,
      currencyCode: 'USD',
    },
    cashBalance: {
      amount: 3000,
      currencyCode: 'USD',
    },
    pendingWithdrawal: {
      amount: 0.0,
      currencyCode: 'USD',
    },
    availableForWithdrawal: {
      amount: 85000,
      currencyCode: 'USD',
    },
    amountSinceInception: {
      amount: 10000,
      currencyCode: 'USD',
    },
  },
  assetAllocation: {
    __typename: 'InvestmentAssetAllocation',
    preference: {
      equities: 70,
      fixedIncome: 20,
      cashEquivalent: 10,
    },
    equities: {
      __typename: 'InvestmentEquitiesAsset',
      amount: {
        amount: 66500,
        currencyCode: 'USD',
      },
      percentage: 70,
      holdings: [
        {
          name: 'Total Stock Market ETF',
          symbol: 'VTI',
          amount: {
            amount: 40000,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 35000,
            currencyCode: 'USD',
          },
          quantity: 150.75,
        },
      ],
      sectors: [
        {
          sector: EquitiesSector.TECHNOLOGY,
          amount: {
            amount: 25000,
            currencyCode: 'USD',
          },
          percentage: 37.6,
          holdings: [
            {
              name: 'Microsoft Corp',
              symbol: 'MSFT',
              costBasis: {
                amount: 12000,
                currencyCode: 'USD',
              },
              amount: {
                amount: 13500,
                currencyCode: 'USD',
              },
              quantity: 32.5,
            },
          ],
        },
      ],
    },
    fixedIncome: {
      __typename: 'InvestmentFixedIncomeAsset',
      amount: {
        amount: 19000,
        currencyCode: 'USD',
      },
      percentage: 20,
      holdings: [
        {
          name: 'Total Bond Market ETF',
          symbol: 'BND',
          amount: {
            amount: 19000,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 18500,
            currencyCode: 'USD',
          },
          quantity: 230,
        },
      ],
      categories: [
        {
          category: FixedIncomeCategory.GOVERNMENT_BONDS,
          percentage: 50,
          amount: {
            amount: 9500,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'Treasury Bond ETF',
              symbol: 'GOVT',
              amount: {
                amount: 9500,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 9200,
                currencyCode: 'USD',
              },
              quantity: 115,
            },
          ],
        },
      ],
    },
    cashEquivalent: {
      __typename: 'InvestmentCashEquivalentAsset',
      amount: {
        amount: 9500,
        currencyCode: 'USD',
      },
      percentage: 10,
      holdings: [
        {
          name: 'Short Term Treasury ETF',
          symbol: 'SHY',
          amount: {
            amount: 9500,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 9400,
            currencyCode: 'USD',
          },
          quantity: 115,
        },
      ],
      categories: [
        {
          category: CashEquivalentCategory.CORPORATE,
          percentage: 100,
          amount: {
            amount: 9500,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'Short Term Treasury ETF',
              symbol: 'SHY',
              amount: {
                amount: 9500,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 9400,
                currencyCode: 'USD',
              },
              quantity: 115,
            },
          ],
        },
      ],
    },
    other: {
      __typename: 'InvestmentOtherAsset',
      amount: {
        amount: 0,
        currencyCode: 'USD',
      },
      percentage: 0,
      holdings: [],
    },
  },
} as InvestmentInheritedRothIRAAccount

export const investmentJointBrokerageTenantsInCommonAccountMock: InvestmentJointBrokerageTenantsInCommonAccount = {
  __typename: 'InvestmentJointBrokerageTenantsInCommonAccount',
  alias: 12,
  accountName: 'Joint Brokerage - Tenants in Common',
  accountNumber: '456789012',
  status: InvestmentAccountStatus.OPEN,
  attributes: {
    minimumDeposit: 250000,
    minimumDepositMet: true,
    acatAllowed: true,
    clientWithdrawalAllowed: true,
    clientDepositAllowed: true,
    iraWithdrawal: {
      withdrawalAmount: 0,
      distributionType: 'QUALIFIED',
    },
  },
  balance: {
    investedBalance: {
      amount: 500000,
      currencyCode: 'USD',
    },
    accountValue: {
      amount: 575000,
      currencyCode: 'USD',
    },
    cashBalance: {
      amount: 25000,
      currencyCode: 'USD',
    },
    pendingWithdrawal: {
      amount: 0.0,
      currencyCode: 'USD',
    },
    availableForWithdrawal: {
      amount: 450000,
      currencyCode: 'USD',
    },
    amountSinceInception: {
      amount: 75000,
      currencyCode: 'USD',
    },
  },
  assetAllocation: {
    __typename: 'InvestmentAssetAllocation',
    preference: {
      equities: 55,
      fixedIncome: 30,
      cashEquivalent: 15,
    },
    equities: {
      __typename: 'InvestmentEquitiesAsset',
      amount: {
        amount: 316250,
        currencyCode: 'USD',
      },
      percentage: 55,
      holdings: [
        {
          name: 'Vanguard Total Market',
          symbol: 'VTI',
          amount: {
            amount: 150000,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 125000,
            currencyCode: 'USD',
          },
          quantity: 625.5,
        },
      ],
      sectors: [
        {
          sector: EquitiesSector.TECHNOLOGY,
          amount: {
            amount: 95000,
            currencyCode: 'USD',
          },
          percentage: 30,
          holdings: [
            {
              name: 'Technology Select ETF',
              symbol: 'XLK',
              costBasis: {
                amount: 80000,
                currencyCode: 'USD',
              },
              amount: {
                amount: 95000,
                currencyCode: 'USD',
              },
              quantity: 500,
            },
          ],
        },
      ],
    },
    fixedIncome: {
      __typename: 'InvestmentFixedIncomeAsset',
      amount: {
        amount: 172500,
        currencyCode: 'USD',
      },
      percentage: 30,
      holdings: [
        {
          name: 'Aggregate Bond ETF',
          symbol: 'AGG',
          amount: {
            amount: 100000,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 95000,
            currencyCode: 'USD',
          },
          quantity: 1000,
        },
      ],
      categories: [
        {
          category: FixedIncomeCategory.GOVERNMENT_BONDS,
          percentage: 40,
          amount: {
            amount: 69000,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'Treasury Long Term ETF',
              symbol: 'TLT',
              amount: {
                amount: 60000,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 55000,
                currencyCode: 'USD',
              },
              quantity: 500,
            },
          ],
        },
      ],
    },
    cashEquivalent: {
      __typename: 'InvestmentCashEquivalentAsset',
      amount: {
        amount: 86250,
        currencyCode: 'USD',
      },
      percentage: 15,
      holdings: [
        {
          name: 'Treasury Bill ETF',
          symbol: 'BILL',
          amount: {
            amount: 60000,
            currencyCode: 'USD',
          },
          costBasis: {
            amount: 59500,
            currencyCode: 'USD',
          },
          quantity: 600,
        },
      ],
      categories: [
        {
          category: CashEquivalentCategory.CORPORATE,
          percentage: 100,
          amount: {
            amount: 86250,
            currencyCode: 'USD',
          },
          holdings: [
            {
              name: 'Treasury Bill ETF',
              symbol: 'BILL',
              amount: {
                amount: 60000,
                currencyCode: 'USD',
              },
              costBasis: {
                amount: 59500,
                currencyCode: 'USD',
              },
              quantity: 600,
            },
          ],
        },
      ],
    },
    other: {
      __typename: 'InvestmentOtherAsset',
      amount: {
        amount: 0,
        currencyCode: 'USD',
      },
      percentage: 0,
      holdings: [],
    },
  },
} as InvestmentJointBrokerageTenantsInCommonAccount

export const investmentJointBrokerageTenantsWithRightOfSurvivorshipAccountMock: InvestmentJointBrokerageTenantsWithRightOfSurvivorshipAccount =
  {
    __typename: 'InvestmentJointBrokerageTenantsWithRightOfSurvivorshipAccount',
    alias: 13,
    accountName: 'Joint Brokerage - Right of Survivorship',
    accountNumber: '567890123',
    status: InvestmentAccountStatus.OPEN,
    attributes: {
      minimumDeposit: 250000,
      minimumDepositMet: true,
      acatAllowed: true,
      clientWithdrawalAllowed: true,
      clientDepositAllowed: true,
      iraWithdrawal: {
        withdrawalAmount: 0,
        distributionType: 'QUALIFIED',
      },
    },
    balance: {
      investedBalance: {
        amount: 750000,
        currencyCode: 'USD',
      },
      accountValue: {
        amount: 825000,
        currencyCode: 'USD',
      },
      cashBalance: {
        amount: 35000,
        currencyCode: 'USD',
      },
      pendingWithdrawal: {
        amount: 0.0,
        currencyCode: 'USD',
      },
      availableForWithdrawal: {
        amount: 700000,
        currencyCode: 'USD',
      },
      amountSinceInception: {
        amount: 75000,
        currencyCode: 'USD',
      },
    },
    assetAllocation: {
      __typename: 'InvestmentAssetAllocation',
      preference: {
        equities: 65,
        fixedIncome: 25,
        cashEquivalent: 10,
      },
      equities: {
        __typename: 'InvestmentEquitiesAsset',
        amount: {
          amount: 536250,
          currencyCode: 'USD',
        },
        percentage: 65,
        holdings: [
          {
            name: 'Growth ETF',
            symbol: 'VUG',
            amount: {
              amount: 300000,
              currencyCode: 'USD',
            },
            costBasis: {
              amount: 250000,
              currencyCode: 'USD',
            },
            quantity: 850.5,
          },
        ],
        sectors: [
          {
            sector: EquitiesSector.TECHNOLOGY,
            amount: {
              amount: 180000,
              currencyCode: 'USD',
            },
            percentage: 33.6,
            holdings: [
              {
                name: 'NASDAQ 100 ETF',
                symbol: 'QQQ',
                costBasis: {
                  amount: 150000,
                  currencyCode: 'USD',
                },
                amount: {
                  amount: 180000,
                  currencyCode: 'USD',
                },
                quantity: 400,
              },
            ],
          },
        ],
      },
      fixedIncome: {
        __typename: 'InvestmentFixedIncomeAsset',
        amount: {
          amount: 206250,
          currencyCode: 'USD',
        },
        percentage: 25,
        holdings: [
          {
            name: 'Intermediate Bond ETF',
            symbol: 'IEF',
            amount: {
              amount: 150000,
              currencyCode: 'USD',
            },
            costBasis: {
              amount: 145000,
              currencyCode: 'USD',
            },
            quantity: 1400,
          },
        ],
        categories: [
          {
            category: FixedIncomeCategory.CORPORATE_BONDS,
            percentage: 50,
            amount: {
              amount: 103125,
              currencyCode: 'USD',
            },
            holdings: [
              {
                name: 'Corporate Bond ETF',
                symbol: 'LQD',
                amount: {
                  amount: 75000,
                  currencyCode: 'USD',
                },
                costBasis: {
                  amount: 72000,
                  currencyCode: 'USD',
                },
                quantity: 600,
              },
            ],
          },
        ],
      },
      cashEquivalent: {
        __typename: 'InvestmentCashEquivalentAsset',
        amount: {
          amount: 82500,
          currencyCode: 'USD',
        },
        percentage: 10,
        holdings: [
          {
            name: 'Money Market ETF',
            symbol: 'VMOT',
            amount: {
              amount: 60000,
              currencyCode: 'USD',
            },
            costBasis: {
              amount: 59800,
              currencyCode: 'USD',
            },
            quantity: 1200,
          },
        ],
        categories: [
          {
            category: CashEquivalentCategory.CORPORATE,
            percentage: 100,
            amount: {
              amount: 82500,
              currencyCode: 'USD',
            },
            holdings: [
              {
                name: 'Money Market ETF',
                symbol: 'VMOT',
                amount: {
                  amount: 60000,
                  currencyCode: 'USD',
                },
                costBasis: {
                  amount: 59800,
                  currencyCode: 'USD',
                },
                quantity: 1200,
              },
            ],
          },
        ],
      },
      other: {
        __typename: 'InvestmentOtherAsset',
        amount: {
          amount: 0,
          currencyCode: 'USD',
        },
        percentage: 0,
        holdings: [],
      },
    },
  } as InvestmentJointBrokerageTenantsWithRightOfSurvivorshipAccount

export const investmentJointBrokerageTenantsInCommonCompanionAccountMock: InvestmentJointBrokerageTenantsInCommonCompanionAccount =
  {
    __typename: 'InvestmentJointBrokerageTenantsInCommonCompanionAccount',
    alias: 14,
    accountName: 'Joint Brokerage Companion - Tenants in Common',
    accountNumber: '678901234',
    status: InvestmentAccountStatus.OPEN,
    attributes: {
      minimumDeposit: 250000,
      minimumDepositMet: true,
      acatAllowed: true,
      clientWithdrawalAllowed: true,
      clientDepositAllowed: true,
      iraWithdrawal: {
        withdrawalAmount: 0,
        distributionType: 'QUALIFIED',
      },
    },
    balance: {
      investedBalance: {
        amount: 125000,
        currencyCode: 'USD',
      },
      accountValue: {
        amount: 140000,
        currencyCode: 'USD',
      },
      cashBalance: {
        amount: 5000,
        currencyCode: 'USD',
      },
      pendingWithdrawal: {
        amount: 0.0,
        currencyCode: 'USD',
      },
      availableForWithdrawal: {
        amount: 120000,
        currencyCode: 'USD',
      },
      amountSinceInception: {
        amount: 15000,
        currencyCode: 'USD',
      },
    },
  } as InvestmentJointBrokerageTenantsInCommonCompanionAccount

export const investmentJointBrokerageTenantsWithRightOfSurvivorshipCompanionAccountMock: InvestmentJointBrokerageTenantsWithRightOfSurvivorshipCompanionAccount =
  {
    __typename: 'InvestmentJointBrokerageTenantsWithRightOfSurvivorshipCompanionAccount',
    alias: 15,
    accountName: 'Joint Brokerage Companion - Right of Survivorship',
    accountNumber: '789012345',
    status: InvestmentAccountStatus.OPEN,
    attributes: {
      minimumDeposit: 250000,
      minimumDepositMet: true,
      acatAllowed: true,
      clientWithdrawalAllowed: true,
      clientDepositAllowed: true,
      iraWithdrawal: {
        withdrawalAmount: 0,
        distributionType: 'QUALIFIED',
      },
    },
    balance: {
      investedBalance: {
        amount: 200000,
        currencyCode: 'USD',
      },
      accountValue: {
        amount: 225000,
        currencyCode: 'USD',
      },
      cashBalance: {
        amount: 10000,
        currencyCode: 'USD',
      },
      pendingWithdrawal: {
        amount: 0.0,
        currencyCode: 'USD',
      },
      availableForWithdrawal: {
        amount: 190000,
        currencyCode: 'USD',
      },
      amountSinceInception: {
        amount: 25000,
        currencyCode: 'USD',
      },
    },
  } as InvestmentJointBrokerageTenantsWithRightOfSurvivorshipCompanionAccount

export const mockGetInvestmentAccountDetailHandler = graphql.query('investmentAccountDetail', () => {
  return HttpResponse.json({ data: { investmentAccountDetail: investmentAccountDetailMock } })
})

export const mockUpdateInvestmentAccountName = graphql.mutation('updateInvestmentAccountName', () => {
  return HttpResponse.json({ data: { updateInvestmentAccountName: updateInvestmentAccountNameMock } })
})

export const mockInvestmentAccountDetail = [mockGetInvestmentAccountDetailHandler, mockUpdateInvestmentAccountName]
